import { authHeader,logout, handleResponse } from '../helpers';
import Vue from 'vue';


export const odlocbaService = {
    load,loadAll,loadLastYear,save,remove
    
};

function load(sezona,pridelovalecid) {
    const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/odlocba/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(odlocba => {
            // login successful if there's a jwt token in the response
            
            return odlocba;
        });
}


function save(odlocba) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(odlocba)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/odlocba`, requestOptions).then(handleResponse);
}


function remove(odlocba) {
    const requestOptions = {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json',...authHeader()},
        body: JSON.stringify(odlocba)
    };

    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/odlocba`, requestOptions).then(handleResponse);
}

function loadAll(sezona){
  const requestOptions = {
        method: 'GET',
        headers:authHeader(),
        
    };


     return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/odlocbe/?sezona=${sezona}`, requestOptions)
        .then(handleResponse)
        .then(odlocba => {
            // login successful if there's a jwt token in the response
            
            return odlocba;
        });
}

function loadLastYear(gerk,status){
    //in tu lahko napišem pravila ali pa jih enostavno potegnem iz baze preko api-ja
    return fetch(`${Vue.prototype.$config.apiUrl}/pridelava/pridelovalec/odlocba/?sezona=${sezona}&pridelovalecid=${pridelovalecid}`, requestOptions)
        .then(handleResponse)
        .then(odlocba => {
            // login successful if there's a jwt token in the response
            
            return odlocba;
        });

}
